import {Box, Container} from "@mui/material";
import React, {useEffect} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {TerminalReleaseForm, Values} from "~/apps/packages/warehouse-closure/components/TerminalReleaseForm/TerminalReleaseForm";
import {useCreateTerminalRelease} from "~/apps/packages/warehouse-closure/hooks";
import {TerminalReleaseFormResult} from "~/apps/packages/warehouse-closure/components/TerminalReleaseFormResult/TerminalReleaseFormResult";
import {BrandAppBar} from "~/apps/core/ui/BrandAppBar";
import {useErrorHandler} from "~/components/ErrorHandling";
import {useUserAuthenticated} from "~/auth/hooks";


export const CreatePage = () => {
    const handleError = useErrorHandler();
    const history = useHistory();
    const userAuthenticated = useUserAuthenticated();
    const [create, {error, data}] = useCreateTerminalRelease();

    useEffect(() => {
        if (data) {
            window.scrollTo(0, 0);
        }
    }, [data]);

    useEffect(() => {
        if (error && !data) {
            handleError(error);
        }
    }, [error, data])

    const handleSubmit = (values: Values) => {
        return create({
            date: values.Date,
            cargos: values.CargoList.map(cargo => ({number: cargo.container.number})),
            contract_number: values.Contract.number,
        });
    }

    const handleBackClick = () => {
        history.goBack();
    }

    const handleGoToMain = () => {
        history.push("/")
    }

    if (data) {
        return (
            <>
                <BrandAppBar onBrandClick={handleGoToMain}/>
                <Box height="56px"/>
                <Container>
                    <Box pt={2} pb={2}>
                        <TerminalReleaseFormResult data={data} onContinue={handleBackClick}/>
                    </Box>
                </Container>
            </>
        )
    }

    return (
        <TitleLayout title="Новая заявка">
            <Box pt={1} pb={1}>
                <TerminalReleaseForm
                    key={String(userAuthenticated)} // reset form after login
                    onSubmit={handleSubmit}
                />
            </Box>
        </TitleLayout>
    );
}